module.exports = __webpack_public_path__ + "img/telegram.308f7370.webp";